import { useEffect, useState } from "react";
import citiesList from "./cities.json";
import { api, DEFAULT_CSS_CLASS, WEATHER_TYPE } from "./utils";


function App() {
  const [query, setQuery] = useState("");
  const [weather, setWeather] = useState({});
  const [weatherCssClass, setWeatherCssClass] = useState(DEFAULT_CSS_CLASS);
  const [matchingCities, setMatchingCities] = useState([]);
  const [statusText, setStatusText] = useState(
    "Please type a city name in search..."
  );

  useEffect(() => {
    const updateAppBG = () => {
      let cssClasses = DEFAULT_CSS_CLASS;
      if (Object.keys(weather).length) {
        const keyName = weather.weather[0]["main"].toLowerCase();
        cssClasses = WEATHER_TYPE[keyName] || DEFAULT_CSS_CLASS;
      }
      setWeatherCssClass(cssClasses);
    };

    updateAppBG();
  }, [weather]);

  const search = (e) => {
    if (e.key === "Enter") {
      fetchCityWeather();
      setMatchingCities([]);
    }
  };

  const fetchCityWeather = (cityName = query) => {
    fetch(`${api.base}weather?q=${cityName}&units=metric&APPID=${api.key}`)
      .then((res) => {
        if (res.status === 404) {
          setStatusText(`"${cityName}" city not found 😥.`);
          return {};
        } else if (res.status !== 200) {
          setStatusText(res.statusText);
          return {};
        } else {
          setStatusText("");
          return res.json();
        }
      })
      .then((result) => {
        setQuery("");
        setWeather(result);
      })
      .catch((err) => {
        console.log("not found", err);
        setWeather({});
        setQuery("");
      });
  };

  const searchSuggestedCity = (city) => {
    setQuery(city);
    setMatchingCities([]);
    fetchCityWeather(city);
  };

  const setQueryHandler = (e) => {
    setQuery(e);
    if (e && e.length >= 3) {
      const matchingCitiesList = citiesList
        .filter((city) => city.name.toLowerCase().includes(e.toLowerCase()))
        .map((y) => y.name);
      setMatchingCities(matchingCitiesList);
    }
  };

  return (
    // Todo optimize the code - State update
    <div className={weatherCssClass}>
      <main>
        <div className="search-box">
          <input
            type="search"
            className="search-bar"
            placeholder="Search"
            onChange={(e) => setQueryHandler(e.target.value)}
            value={query}
            onKeyPress={search}
          />

          {matchingCities.length ? (
            <div className="suggestion-box">
              {matchingCities.map((city, idx) => (
                <button
                  onClick={() => searchSuggestedCity(city)}
                  className="pill"
                  key={idx}
                >
                  {city}
                </button>
              ))}
            </div>
          ) : null}
        </div>

        {!Object.keys(weather).length && (
          <>
            <div className="location-box">
              <div className="location">{statusText}</div>
            </div>
          </>
        )}

        {Object.keys(weather).length ? (
          <div>
            <div className="location-box">
              <div className="location">
                {weather.name}, {weather.sys.country}
              </div>
            </div>
            <div className="weather-box">
              <div className="temp">{Math.round(weather.main.temp)}&deg;c</div>
              <div className="weather">{weather.weather[0]["main"]}</div>
              <small>{weather.weather[0]["description"]}</small>
            </div>
          </div>
        ) : null}
      </main>
    </div>
  );
}

export default App;
